import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { useEffect } from "react";

import { UIComponent } from "./UIComponent";
import { AppErrorFormik } from "../AppErrorFormik";

export const AppTextArea = ({ name, label, placeholder, rows = "4", preloadedInfoFromBackend, ...otherProps }) => {
  const { handleBlur, handleChange, setFieldValue, errors, touched, values, resetForm } = useFormikContext();

  // If preloadedInfoFromBackend, setting initials values on formik
  useEffect(() => {
    resetForm();
  }, [resetForm]);

  useEffect(() => {
    if (preloadedInfoFromBackend) {
      setFieldValue(name, preloadedInfoFromBackend);
    }
  }, [preloadedInfoFromBackend, name, setFieldValue]);
  return (
    <>
      <UIComponent
        onBlur={handleBlur}
        onChange={handleChange}
        label={label}
        value={values[name]}
        {...otherProps}
        name={name}
        rows={rows}
        cols="50"
        role="textbox"
        placeholder={!placeholder ? label : placeholder}
      />
      <AppErrorFormik error={errors[name]} visible={touched[name]} />
    </>
  );
};

AppTextArea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.string,
  preloadedInfoFromBackend: PropTypes.string,
};
